import { render, staticRenderFns } from "./ResourceDashboard.vue?vue&type=template&id=e86721c6&scoped=true&"
import script from "./ResourceDashboard.vue?vue&type=script&lang=js&"
export * from "./ResourceDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ResourceDashboard.vue?vue&type=style&index=0&id=e86721c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e86721c6",
  null
  
)

export default component.exports